import { DreamBlock } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_ACCORDION, ELEMENT_ACCORDION_ITEM } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { AccordionRootElementEditor } from './components/AccordionRootElement';
import { createAccordionItemPlugin } from './createAccordionItemPlugin';
import { getDefaultAccordionValue } from './defaults';
import { withAccordion } from './withAccordion';

export const createAccordionPlugin = createTElementPluginFactory({
  key: ELEMENT_ACCORDION,
  component: withDropTarget(AccordionRootElementEditor as ComponentType<TRenderElementProps>),
  withOverrides: withAccordion,
  plugins: [createAccordionItemPlugin()],
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: true,
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/accordion.png',
      title: 'Accordion',
      subtitle:
        'A vertically stacked set of interactive headings that each reveal an associated section of content',
      keywords: ['accordion', 'toggle list'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      insertNode: getDefaultAccordionValue() as unknown as DreamBlock,
      turnInto: [],
      focusableWhenEmpty: false,
      validProperties: ['style', 'width', 'width_max', 'connect_data', 'margin'],
      validChildrenTypes: [ELEMENT_ACCORDION_ITEM],
    },
  },
});
